export class PedidoModel {
    constructor(
        public id: string = '',
        public dataCriacao: string = '',
        public systemUpdateDate: string = '',
        public systemInsertDate: string = '',
        public dataAgendamentoFinal: string = '',
        public dataAgendamentoInicial: string = '',
        public mesaId: string = '',
        public mesaCodigo: string = '',
        public salaoId: string = '',
        public salao: string = '',
        public comandaId: string = '',
        public codigoComanda: string = '',
        public tipoPedido: CodigoDescricao = new CodigoDescricao(),
        public statusPedido: CodigoDescricao = new CodigoDescricao(),
        public statusAutomacao: CodigoDescricao = new CodigoDescricao(),
        public codigoPedido: string = '',
        public identificador: string = '',
        public codigoReferencia: string = '',
        public posicaoMesa: string = '',
        public documentoLoja: string = '',
        public quantidadePessoas: number = 0,
        public informacaoAdicional: string = '',
        public aplicarDescontoEcommerce: boolean = false,
        public operadorId: string = '',
        public operador: string = '',
        public taxaDeServico: number = 0,
        public valorTotalFrete: number = 0,
        public valorTotalPedido: number = 0,
        public valorTotalServico: number = 0,
        public valorTotalDesconto: number = 0,
        public valorTotalAcrescimo: number = 0,
        public cliente: Cliente = new Cliente(),
        public produtos: PedidoProdutoModel[] = [],
        public enderecoEntrega: EnderecoEntrega = new EnderecoEntrega(),
        public dadosIntegracao: DadosIntegracao = new DadosIntegracao(),
        public pagamentos: Pagamento[] = [],
    ) { }
}

export class CodigoDescricao {
    constructor(
        public codigo: number = 0,
        public descricao: string = '',
    ) { }
}

export class Cliente {
    constructor(
        public referenceId: string = '',
        public nomeFantasia: string = '',
        public razaoSocial: string = '',
        public email: string = '',
        public cpfCnpj: string = '',
        public ieRg: string = '',
        public dataNascimento: string = '',
        public telefone: string = '',
    ) { }
}

export class PedidoProdutoModel {
    constructor(
        public id: string = '',
        public setorId: string = '',
        public adicionalId: string = '',
        public indFin: boolean = true,
        public cliente: string = '',
        public vendedor: string = '',
        public vendedorId: string = '',
        public produtoPai: string = '',
        public plu: string = '',
        public descricao: string = '',
        public observacao: string = '',
        public pesoVariavel: boolean = true,
        public codigoBarra: string = '',
        public tpProduto: CodigoDescricao = new CodigoDescricao(),
        public status: CodigoDescricao = new CodigoDescricao(),
        public indDesperdicio: CodigoDescricao = new CodigoDescricao(),
        public nItem: number = 0,
        public posicaoMesa: string = '',
        public codigoReferencia: string = '',
        public groupId: string = '',
        public quantidade: number = 0,
        public valorUnitario: number = 0,
        public valorTotal: number = 0,
        public taxaServico: number = 0,
        public valorTotalFrete: number = 0,
        public valorTotalServico: number = 0,
        public valorTotalSubItens: number = 0,
        public valorTotalDesconto: number = 0,
        public valorTotalAdicional: number = 0,
        public subItens: PedidoProdutoModel[] = [],
        public systemInsertDate: string,
        public systemUpdateDate: string,
        public produtoIdReferencia: string = '',
    ) { }
}

export class EnderecoEntrega {
    constructor(
        public logradouro: string = '',
        public numero: string = '',
        public bairro: string = '',
        public municipio: string = '',
        public uf: string = '',
        public cep: string = '',
        public latitude: number = 0,
        public longitude: number = 0,
        public complemento: string = '',
        public enderecoCompleto: string = '',
        public pais: string = '',
        public pontoReferencia: string = '',
        public codigoMunicipio: string = '',
    ) { }
}

export class DadosIntegracao {
    constructor(
        public nomeIntegrador: string = '',
        public cnpjIntegrador: string = '',
        public credencialCliente: string = '',
        public codigoAplicacao: number = 0,
    ) { }
}

export class Pagamento {
    constructor(
        public id: string = '',
        public pagamentoId: string = '',
        public pagamentoDescricao: string = '',
        public valorPago: number = 0,
        public pagamentoPessoa: string = '',
        public tpMod: TpMod = new TpMod(),
        public transacoes: string[] = [],
        public pagamentoAReceber: boolean,
        public valorTroco: number,
        public situacao: CodigoDescricao = new CodigoDescricao(),
        public systemInsertDate: string = '',
    ) { }
}

export class TpMod {
    constructor(
        public codigo: number = 0,
        public descricao: string = '',
    ) { }
}

